module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-alert', {
    attrs: {
      "color": "error",
      "icon": "error",
      "dismissible": "",
      "value": true
    },
    on: {
      "input": _vm.onClose
    }
  }, [_vm._v("\n      " + _vm._s(_vm.text) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a3496a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/Alert.vue
// module id = 662
// module chunks = 1